var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
var Highlighted = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: var(--color-yellow-60);\n"], ["\n  background-color: var(--color-yellow-60);\n"])));
var Highlighter = function (props) {
    var value = props.value, _a = props.element, element = _a === void 0 ? 'em' : _a;
    if (!value)
        return null;
    var regex = new RegExp("<".concat(element, ">(.*?)</").concat(element, ">"));
    var parts = value.split(regex);
    return (_jsx(_Fragment, { children: parts.map(function (part) {
            if (!value.includes("<".concat(element, ">").concat(part, "</").concat(element, ">"))) {
                return "".concat(part);
            }
            return _jsx(Highlighted, { children: part });
        }) }));
};
export default Highlighter;
var templateObject_1;
//# sourceMappingURL=Highlighter.js.map